import FsLightbox from "fslightbox-react"
import React, { useState } from "react"
import { Image } from "react-datocms"
import * as styles from "./PostHeader.module.scss"
import useMediaQuery from "@lib/useMediaQuery"
import Breadcrumbs from "@components/global/Breadcrumbs/Breadcrumbs"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import playButton from "@images/icons/playIcon.svg"
import noimage from "@images/noImage.png"

const PostHeader = (props) => {
  // Resize control
  const isMobile = useMediaQuery(767)

  const [toggleLightBox, setToggleLightBox] = useState(false)

  const breadcrumbs = props.breadcrumbs ? (
    <Breadcrumbs color="blue" elements={[["Top Tips", "/top-tips"], props.title]} />
  ) : (
    <div className={styles.spacer} />
  )

  return (
    <section className={styles.PostHeader}>
      <SiteWrapper>{!isMobile && breadcrumbs}</SiteWrapper>

      <SiteWrapper narrow desktopOnly className={styles.intro}>
        <div className={styles.featuredImage}>
          {props.featuredImage ? <Image data={props.featuredImage.responsiveImage} /> : <img src={noimage} alt="" />}

          {props.video && (
            <div className={styles.playButton} onClick={() => setToggleLightBox(!toggleLightBox)}>
              <img src={playButton} alt="play video" />
            </div>
          )}
        </div>

        <SiteWrapper mobileOnly className={styles.info}>
          {isMobile && breadcrumbs}
          <h1>{props.title}</h1>
          <span>By{props.author ? ` ${props.author.name}` : " HOPP"}</span>
        </SiteWrapper>
      </SiteWrapper>

      {/* datoCMS doesnt pass correct url from vimeo and fslightbox doesnt support vimeo source */}
      {props.video && (
        <FsLightbox
          className={styles.lightBox}
          toggler={toggleLightBox}
          sources={props.video.provider === "youtube" ? [props.video.url] : null}
          customSources={
            props.video.provider === "vimeo"
              ? [
                  <iframe
                    title={props.video.title}
                    src={`https://player.vimeo.com/video/${props.video.providerUid}`}
                    width={props.video.width}
                    height={props.video.height}
                    frameBorder="0"
                    allow="autoplay; fullscreen"
                    allowFullScreen
                  />,
                ]
              : null
          }
        />
      )}
    </section>
  )
}

export default PostHeader
